<template>
    <div>
      <b-card>
        <b-row>
          <b-col
            v-for="[typeKey, typeLabel] in parameterTypes"
            :key="typeKey"
            md="6"
          >
            <h4 class="mt-2">{{ typeLabel }}</h4>
  
            <b-col
              v-for="(param, index) in form[typeKey]"
              :key="typeKey + '-' + index"
              cols="12"
              class="d-flex mb-2"
            >
              <b-form-input
                v-model="param.key"
                placeholder="Anahtar"
                class="mr-1"
                :readonly="isProtectedKey(param.key)"
                :class="{ 'text-info': isProtectedKey(param.key) }"
              />
              <b-form-input
                v-model="param.value"
                placeholder="Değer"
                class="mr-1"
              />
              <b-button
                v-if="!isProtectedKey(param.key)"
                variant="danger"
                @click="removeParam(typeKey, index)"
              >
                Sil
              </b-button>
            </b-col>
  
            <b-col cols="12" class="mb-2">
              <b-button size="sm" variant="success" @click="addParam(typeKey)">
                + Yeni Parametre
              </b-button>
              <b-button size="sm" variant="primary" class="ml-1" @click="saveGroup(typeKey)">
                Kaydet
              </b-button>
            </b-col>
  
            <hr />
          </b-col>
        </b-row>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BCard, BButton, BFormInput, BRow, BCol,
  } from 'bootstrap-vue'
  import axios from 'axios'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  
  export default {
    components: {
      BCard,
      BButton,
      BFormInput,
      BRow,
      BCol,
    },
    data() {
      return {
        form: {
          sms_parameters: [],
          story_parameters: [],
          bio_parameters: [],
          inf_parameters: [],
        },
        parameterTypes: [
          ['inf_parameters', 'Influencer Parametreleri'],
          ['sms_parameters', 'SMS Parametreleri'],
          ['story_parameters', 'Story Parametreleri'],
          ['bio_parameters', 'Bio Parametreleri'],
          ['whatsapp_parameters', 'Whatsapp Parametreleri'],
        ],
      }
    },
    mounted() {
      this.$http.get('/utm-parameters', { params: { source: 'list' } })
        .then(res => {
          const allData = res.data.data
          const data = Array.isArray(allData) ? allData[0] : allData
  
          this.form.sms_parameters = this.ensureProtected(this.formatJson(data.sms_parameters))
          this.form.story_parameters = this.ensureProtected(this.formatJson(data.story_parameters))
          this.form.bio_parameters = this.ensureProtected(this.formatJson(data.bio_parameters))
          this.form.inf_parameters = this.ensureProtected(this.formatJson(data.inf_parameters))
          this.form.whatsapp_parameters = this.ensureProtected(this.formatJson(data.whatsapp_parameters))
        })
        .catch(() => {
          this.parameterTypes.forEach(([type]) => {
            this.form[type] = this.ensureProtected([])
          })
        })
    },
    methods: {
      formatJson(jsonStr) {
        try {
          const parsed = JSON.parse(jsonStr)
          return Object.entries(parsed).map(([key, value]) => ({ key, value }))
        } catch {
          return []
        }
      },
      convertToJson(paramArray) {
        const obj = {}
        paramArray.forEach(p => {
          if (p.key) obj[p.key] = p.value
        })
        return obj
      },
      isProtectedKey(key) {
        return ['utm_source', 'utm_medium'].includes(key)
      },
      ensureProtected(paramList) {
        const keys = paramList.map(p => p.key)
        const required = ['utm_source', 'utm_medium']
        required.forEach(protectedKey => {
          if (!keys.includes(protectedKey)) {
            paramList.unshift({ key: protectedKey, value: '' })
          }
        })
        return paramList
      },
      addParam(type) {
        this.form[type].push({ key: '', value: '' })
      },
      removeParam(type, index) {
        this.form[type].splice(index, 1)
      },
      saveGroup(typeKey) {
        const paramList = this.form[typeKey]
  
        const hasEmptyField = paramList.some(p => !p.key || !p.value)
  
        if (hasEmptyField) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Eksik Bilgi',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
              text: 'Lütfen tüm anahtar ve değer alanlarını doldurun.',
            },
          })
          return
        }
  
        const payload = {
          [typeKey]: this.convertToJson(paramList)
        }
  
        this.$http.put('/utm-parameters', payload)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Başarılı',
                icon: 'CheckIcon',
                variant: 'success',
                text: `${this.getLabel(typeKey)} güncellendi.`,
              },
            })
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Hata',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: `${this.getLabel(typeKey)} kaydedilirken hata oluştu.`,
              },
            })
          })
      },
      getLabel(typeKey) {
        const found = this.parameterTypes.find(([key]) => key === typeKey)
        return found ? found[1] : typeKey
      },
    },
  }
  </script>
  
  <style scoped>
  .text-info {
    font-weight: bold;
    color: #17a2b8;
  }
  </style>
  